import { render, staticRenderFns } from "./AddNoteDialog.vue?vue&type=template&id=c482f46a&"
import script from "./AddNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports